
import { useMemo } from 'react';
import _ from 'lodash';
import Select from 'react-select';
import { VehcileAvailabilityEnum } from '../../../../api'
import i18next from 'i18next';  // Import the i18next instance
import { useTranslation } from 'react-i18next';
import { changeHorizonSpainToHorizon } from '../../../../utils';
import CreatableSelect from 'react-select/creatable';

const LABELS = {
	stato_disp: {
		TARGATO: i18next.t('registered').toUpperCase(),
		IN_ARRIVO: i18next.t('incoming').toUpperCase(),
		TELAIATO: i18next.t('framed').toUpperCase(),
		ORDINATO: i18next.t('ordered').toUpperCase()
	},
	stato_corrente: {
		DISPONIBILE: i18next.t('available').toUpperCase(),
		OPZIONATO: i18next.t('optioned').toUpperCase(),
		VENDUTO: i18next.t('sold').toUpperCase(),
		OSCURATO: i18next.t('obscured').toUpperCase(),
	}
};

// si potrebbe dare consistenza alle labels. lowercase e capitalize.
// const getLabel = (columnId, value: string) => {
// 	let label = LABELS[columnId]?.[value] || value;
// 	return label
// };

const getLabel = (columnId, value) => {
	// For the 'dealer' column, apply the changeHorizonSpainToHorizon transformation
	if (columnId === 'dealer' && value) {
		return changeHorizonSpainToHorizon(value);
	}
	// For other columns, use the LABELS mapping or fallback to the value
	return LABELS[columnId]?.[value] || value;
};

const ColumnFilterMultiSelect = ({
	props,
	column: { filterValue, setFilter, preFilteredRows, id },
}) => {
	const { t } = useTranslation()
	const { filterState, setFilterState, isCreatable, options: injected } = props; // arrivano dal render in VehicleFilters.tsx
	const options = useMemo(() => {
		if (injected) return injected;

		let options: any = [];

		preFilteredRows.forEach((row) => {
			if (!row.values[id]) return;

			if (!options.find((opt) => opt.value === row.values[id])) {
				options.push({
					id: id,
					value: row.values[id],
					label: getLabel(id, row.values[id]),
				});
			}
		});

		// list here all the options which should have sorted items in the select
		if (['marca', 'modello'].indexOf(id) > -1) {
			options = _.orderBy(options, ['label'], ['asc'])
		}

		return [...options];
	}, [id, preFilteredRows, injected]);


	const selectedOptions = filterState[id]?.map((value) => {
		return { id, value, label: getLabel(id, value) };
	});


	const handleChange = (optionArr) => {

		setFilterState((prevState) => {
			return {
				...prevState,
				[id]: optionArr.map((item) => item.value),
			};
		});
	};

	const SelectComponent  = isCreatable ? CreatableSelect : Select;

	return (
		<SelectComponent
			menuPosition="fixed"
			placeholder={t('select')}
			isMulti
			className="multiselect"
			name={id}
			value={selectedOptions}
			options={options}
			onChange={handleChange}
			formatCreateLabel={(value) => value}
		/>
	);
};

export default ColumnFilterMultiSelect;
